module.exports = __webpack_public_path__ + "static/media/myopic-vision.0e0d9216.png";